// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStarFullIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M22.12 9.621a1.06 1.06 0 0 0-1.009-.733h-6.18l-1.913-5.88a1.06 1.06 0 0 0-1.01-.734c-.457 0-.872.299-1.01.734l-1.913 5.88H2.907c-.457 0-.871.297-1.01.733-.138.436.011.915.382 1.191l4.998 3.636-1.914 5.88c-.137.436.011.914.383 1.191.372.276.883.276 1.254 0l4.997-3.636 4.998 3.636c.192.138.404.202.628.202s.436-.064.627-.202c.372-.266.532-.755.382-1.191l-1.913-5.88 4.997-3.636c.372-.265.531-.755.383-1.191z" />
  </g>
);
export default SvgStarFullIcon;
SvgStarFullIcon.displayName = 'SvgStarFullIcon';
